{
  "loading": "Laster...",
  "noDataAvailable": "Ingen data tilgjengelig",
  "owner": "Eier",
  "owners": "Eiere",
  "sections": {
    "forestownerInformation": "Skogeierinformasjon",
    "supplierInformation": "Leverandørinformasjon"
  },
  "typeLabel": "Type",
  "registeredLabel": "Registrert",
  "supplierNumberLabel": "Leverandørnummer",
  "areaDistribution": {
    "title": "Arealfordeling",
    "description": "Oversikt over areal på denne eiendommen",
    "totalAreaLabel": "Totalareal",
    "productiveAreaLabel": "Produktivt areal",
    "protectedAreaLabel": "Vernet areal",
    "legend": {
      "productiveArea": "Produktivt areal",
      "protectedArea": "Vernet areal",
      "otherArea": "Annet areal"
    },
    "editProtectedArea": "Endre vernet areal"
  },
  "shareOwnership": {
    "numberOfSharesTitle": "Antall andeler",
    "notCooperativeMember": "Ikke andelseier",
    "registerNewShareOwnership": "Registrer nytt andelseierskap"
  },
  "landQualityDistribution": {
    "title": "Bonitetsfordeling",
    "description": "Produktivt skogsareal fordelt på bonitet",
    "high": "Høy bonitet",
    "medium": "Middels bonitet",
    "low": "Lav bonitet",
    "inTotal": "totalt",
    "table": {
      "header": "Bonitet",
      "category": "Bonitet",
      "area": "Areal",
      "factor": "Faktor",
      "shares": "Andeler",
      "rows": {
        "high": "Høy",
        "medium": "Middels",
        "low": "Lav"
      }
    }
  }
}
